/* jshint esversion: 6 */
/* jshint ignore:start */
import { createContext, useState, useRef, useEffect } from 'react';
import secureLocalStorage from 'react-secure-storage';
const MyContext = createContext();
const MyProvider = ({ children }) => {

    const BaseUrl = "https://fixora.cscodetech.cloud/";

    const [islogin, setIsLogin] = useState(0);
    const [totalcart, setTotalCart] = useState(0);
    const [isshowadsbox, setIsShowAdsBox] = useState(false);
    const [selectads, setSelectAds] = useState("");
    const [paymentloading, setPaymentLoading] = useState(false);
    const [paymentRes, setPaymentRes] = useState("");
    const [ischnagelocation, setIsChangeLocation] = useState(0);
    const [isInstallable, setIsInstallable] = useState(false);
    const [MapKey, setMapKey] = useState("");
    const [catlist, setCatList] = useState([]);
    const [oneSignalAppId, setOneSignalAppId] = useState("63685954-ba6e-4c3a-9ef9-33ddd082951e");

    const AddressRef = useRef();

    useEffect(() => {
        const LocalMapKey = secureLocalStorage.getItem("mapkey");
        setMapKey(LocalMapKey);
    }, []);


    const value = {
        islogin, setIsLogin,
        totalcart, setTotalCart,
        isshowadsbox, setIsShowAdsBox,
        selectads, setSelectAds,
        paymentloading, setPaymentLoading,
        paymentRes, setPaymentRes,
        ischnagelocation, setIsChangeLocation,
        isInstallable, setIsInstallable,
        catlist, setCatList,
        MapKey, setMapKey,
        oneSignalAppId, setOneSignalAppId,
        BaseUrl, AddressRef
    };

    return (
        <MyContext.Provider value={value}>
            {children}
        </MyContext.Provider>
    )
}

export { MyContext, MyProvider }
/* jshint ignore:end */